module.exports = __webpack_public_path__ + "img/footer_gzh.65ae4cd0.png";